//client/src/pages/ResetPassword.tsx
import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { supabase } from '../supabase';

export default function ResetPassword() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') || '';
    const email = searchParams.get('email') || '';
    const [newPassword, setNewPassword] = useState('');
    const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
    const [errorMsg, setErrorMsg] = useState('');

    useEffect(() => {
        async function verify() {
            setStatus('loading');
            const { error } = await supabase.auth.verifyOtp({
                type: 'recovery',
                token,
                email,
            });
            if (error) {
                setErrorMsg(error.message);
                setStatus('error');
            } else {
                setStatus('idle');
            }
        }
        verify();
    }, [token, email]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setStatus('loading');
        const { error } = await supabase.auth.updateUser({ password: newPassword });
        if (error) {
            setErrorMsg(error.message);
            setStatus('error');
        } else {
            setStatus('success');
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
            <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6">
                <h2 className="text-2xl font-semibold mb-4">Reset Your Password</h2>

                {status === 'loading' && <p>Verifying reset link…</p>}

                {status === 'error' && (
                    <>
                        <p className="text-red-600 mb-2">Error: {errorMsg}</p>
                        <p>Please request a new reset link.</p>
                    </>
                )}

                {status === 'idle' && (
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <label className="block">
                            New Password
                            <input
                                type="password"
                                required
                                value={newPassword}
                                onChange={e => setNewPassword(e.target.value)}
                                className="w-full border p-2 rounded mt-1"
                            />
                        </label>
                        <button
                            type="submit"
                            className="w-full py-2 bg-green-600 text-white rounded"
                        >
                            Update Password
                        </button>
                    </form>
                )}

                {status === 'success' && (
                    <>
                        <p className="text-green-700 mb-4">✅ Your password has been updated.</p>
                        <Link to="/login" className="px-4 py-2 bg-blue-600 text-white rounded">
                            Go to Login
                        </Link>
                    </>
                )}
            </div>
        </div>
    );
}
